import React, { useEffect } from "react";
import { X } from "lucide-react";

/** Shared admin modal: dim background + scrollable centered content. Closes on backdrop click or Escape. */
export function AdminModal({ onClose, children, testid = "admin-modal", maxWidth = "max-w-3xl" }) {
    useEffect(() => {
        const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onClose]);

    return (
        <div
            className="fixed inset-0 z-50 flex items-start md:items-center justify-center bg-black/80 p-4 overflow-y-auto"
            onClick={onClose}
            data-testid={testid}
        >
            <div
                className={`bg-zinc-950 border border-zinc-800 ${maxWidth} w-full max-h-[92vh] overflow-y-auto p-6 my-4`}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    className="float-right text-zinc-500 hover:text-white"
                    data-testid={`${testid}-close`}
                    aria-label="Fermer"
                >
                    <X size={20} />
                </button>
                {children}
            </div>
        </div>
    );
}
